import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale.js';
import utc from 'dayjs/plugin/utc.js';
import { z } from 'zod';
dayjs.extend(utc);
dayjs.extend(updateLocale);
/**
 * updateLocale merges into the built-in 'en' locale; dayjs.locale('en', {...}) would replace it
 * entirely and lose the month/weekday names needed by 'MMMM'-style formats.
 */
dayjs.updateLocale('en', {
    weekStart: 1
});
export const CustomDateZodSchema = z.object({
    year: z.number(),
    month: z.number().min(1).max(12),
    day: z.number().min(1).max(31)
});
export function dateToCustomDate(date) {
    if (isNaN(date.getTime())) {
        throw new Error('Invalid date provided');
    }
    const utcDate = dayjs(date).set('hour', 12).set('minute', 0).set('second', 0).set('millisecond', 0).utc();
    return {
        year: utcDate.year(),
        month: utcDate.month() + 1,
        day: utcDate.date()
    };
}
export function customDateToDate(customDate) {
    return customDateToDayJsDate(customDate).toDate();
}
export function customDateToDayJsDate(customDate) {
    const { year, month, day } = customDate;
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
        throw new Error('Invalid custom date provided');
    }
    return dayjs.utc(`${year}-${month}-${day}`, 'YYYY-M-D').utcOffset(0).startOf('day');
}
//# sourceMappingURL=date.model.js.map